<ng-container *transloco="let tr; prefix: 'promoBanners'; scope: 'promo-banners'">
  <nz-affix [nzOffsetTop]="0">
    <nz-page-header [nzGhost]="false">
      <nz-page-header-title>{{tr('title')}}</nz-page-header-title>
      <nz-page-header-subtitle>{{tr('subTitle')}}</nz-page-header-subtitle>
      <nz-page-header-extra>
        <a routerLink="new" nz-button nzType="primary">
          <i nz-icon nzType="plus-circle" nzTheme="outline"></i> {{'button.addNew' | transloco}}
        </a>
      </nz-page-header-extra>
    </nz-page-header>
  </nz-affix>

  <nz-collapse nzBordered="false">
    <nz-collapse-panel [nzHeader]="'filters' | transloco" [nzActive]="true">
      <div nz-row [nzGutter]="[16,24]">
        <div nz-col>
          <small>{{tr('filter.cityId')}}</small>
          <hx-city-select [(ngModel)]="filter.cityId" (ngModelChange)="applyFilters()"></hx-city-select>
        </div>
      </div>
    </nz-collapse-panel>
  </nz-collapse>

  <nz-table [nzLoading]="isTableLoading"
            [nzTotal]="total"
            [nzPageSize]="limit"
            [nzPageIndex]="page"
            [nzData]="list"
            (nzQueryParams)="onQueryParamsChange($event)"
            [nzFrontPagination]="false">
    <thead>
    <tr>
      <th nzColumnKey="name" [nzSortOrder]="columnSortOrderMap.get('name') || null" [nzSortFn]="true"
          [nzSortPriority]="1">{{tr('column.name')}}</th>
      <th nzColumnKey="title">{{tr('column.title')}}</th>
      <th nzColumnKey="date">{{tr('column.date')}}</th>
      <th nzColumnKey="sortOrder">{{tr('column.sortOrder')}}</th>
      <th nzWidth="100px">#</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let data of list">
      <td>
        <div><strong>{{ data.name }}</strong></div>
        <nz-tag *ngIf="data.banner" [nzColor]="'blue'">{{tr('column.banner')}}</nz-tag>
        <nz-tag *ngIf="data.promo" [nzColor]="'cyan'">{{tr('column.promo')}}</nz-tag>
        <nz-tag *ngIf="data.mainBanner" [nzColor]="'green'">{{tr('column.mainBanner')}}</nz-tag>
      </td>
      <td>{{ data.title | json }}</td>
      <td>
        {{ data.startDate }}
        <ng-container *ngIf="data.endDate"> - {{data.endDate}}</ng-container>
      </td>
      <td>{{ data.sortOrder }}</td>
      <td>
        <nz-button-group>
          <button [routerLink]="data.id + '/edit'" nz-button nzType="primary">
            <i nz-icon nzType="edit" nzTheme="outline"></i>
          </button>
          <button nz-button nzType="default" nzDanger nz-popconfirm
                  [nzPopconfirmTitle]="'remove.popconfirm' | transloco" [nzOkText]="'yes' | transloco"
                  [nzCancelText]="'no1' | transloco"
                  (nzOnConfirm)="remove(data)">
            <i nz-icon nzType="delete" nzTheme="outline"></i>
          </button>
        </nz-button-group>
      </td>
    </tr>
    </tbody>
  </nz-table>
</ng-container>
